import React from 'react';
// @ts-ignore
import css from "./sliderDownload.module.scss";
// import imagePDFReady from "../../../svg/pdf/pdf-loading-image.svg";
import {formatInternationalPhoneNumber} from "../../helpers";
// import testImage from './../../../images/main-photo.png'

const SliderDownload = ({ hcDesc, images, dataAgent, slideIndex }) => {

    const agentFields = {
        name: dataAgent?.name,
        phone: dataAgent?.phone,
        email: dataAgent?.email,
    }

    return (
        <div className={`${css.sectionSliderDownload} pdf-slide`}>
            <div className={css.image} style={{
                backgroundImage: `url(${images[0].links.original})`,
                // images[0].links.original
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom center",
            }}>
            </div>
            <div className={css.sliderInfo}>
                <div className={css.sliderInfoContent}>
                    <div className={css.sliderInfoContent__name}>
                        <p>{hcDesc.name}</p>
                    </div>
                    <div className={css.sliderInfoContent__address}>
                        <p className={css.sliderInfoContentLabel}>Адрес</p>
                        <p className={css.sliderInfoContentContent}>{hcDesc.address}</p>
                    </div>
                    <div className={css.sliderInfoContent__objects}>
                        <p className={css.sliderInfoContentLabel}>Количество объектов</p>
                        <p className={css.sliderInfoContentContent}>{hcDesc.lots}</p>
                    </div>
                </div>
                <div className={css.sliderInfo__footer}>
                    <div className={css.sliderInfo__footer}>
                        <ul className={css.sliderInfo__list}>
                            {dataAgent && Object.entries(agentFields).map(([key, value]) => (
                                value && (
                                    <li
                                        key={key}
                                        className={`${css.sliderInfo__listItem} ${key === 'name' ? css.sliderInfoValueBold : css.sliderInfoValue}`}
                                    >
                                        {
                                            key === 'phone' ? formatInternationalPhoneNumber(value, 'RU') : value
                                        }
                                    </li>
                                )
                            ))}
                        </ul>
                        <span className={css.sliderInfo__countPage}>{slideIndex}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SliderDownload;